export const validConversionPrice = new RegExp(/^\d*\.?\d*$/);
export const validateTagSeparator = new RegExp(/^[!@#$%^&*(),.?":{}|<>_\-^]*$/);

